// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.card-list-shopper{
    background-color: #555555;
    border-radius: 9px;
    height: 100px;
    display: flex;
    color: white;
    padding: 0px 10px;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    margin-left:0px;
    position: relative;
}
.image-client{
    background-size: cover;
    width: 200px;
    height: 200px;
    border-radius: 50%;
}

.card-list-shopper-name{
    font-size: 1.1rem;
    display: block;
    text-align: right;

}
.card-list-shopper:hover {
    opacity: .8;
    cursor: pointer;
    transition: 0.5s;
}
.card-list-shopper-cnpj_cpf{
    font-size: 0.95rem;
    display: block;
    text-align: right;


}
.card-list-shopper-mobile{
    font-size: 0.95rem;
    display: block;
    text-align: right;

}
.icon-image{
    width: 20px;
    margin-top: -3px;
}
.icon-active{
    border-radius: 50%;
    position: absolute;
    top: 15px;
    left: 7px;
    width: 30px;
    height: 30px;
    padding: 3px 4px;

}
.normal {
    background-color: #43af55;
}
.suspended{
    background-color: #f58e08;
    padding: 3px 6px;
}
.pending{
    background-color: #ede600e6;

}
.canceled{
    background-color: #c73b3b;

}`, "",{"version":3,"sources":["webpack://./src/components/componentsCss/ListCardShoppers.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,YAAY;IACZ,iBAAiB;IACjB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,iBAAiB;;AAErB;AACA;IACI,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;;;AAGrB;AACA;IACI,kBAAkB;IAClB,cAAc;IACd,iBAAiB;;AAErB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;;AAEpB;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,yBAAyB;IACzB,gBAAgB;AACpB;AACA;IACI,2BAA2B;;AAE/B;AACA;IACI,yBAAyB;;AAE7B","sourcesContent":[".card-list-shopper{\n    background-color: #555555;\n    border-radius: 9px;\n    height: 100px;\n    display: flex;\n    color: white;\n    padding: 0px 10px;\n    align-items: center;\n    justify-content: space-between;\n    margin-top: 10px;\n    margin-left:0px;\n    position: relative;\n}\n.image-client{\n    background-size: cover;\n    width: 200px;\n    height: 200px;\n    border-radius: 50%;\n}\n\n.card-list-shopper-name{\n    font-size: 1.1rem;\n    display: block;\n    text-align: right;\n\n}\n.card-list-shopper:hover {\n    opacity: .8;\n    cursor: pointer;\n    transition: 0.5s;\n}\n.card-list-shopper-cnpj_cpf{\n    font-size: 0.95rem;\n    display: block;\n    text-align: right;\n\n\n}\n.card-list-shopper-mobile{\n    font-size: 0.95rem;\n    display: block;\n    text-align: right;\n\n}\n.icon-image{\n    width: 20px;\n    margin-top: -3px;\n}\n.icon-active{\n    border-radius: 50%;\n    position: absolute;\n    top: 15px;\n    left: 7px;\n    width: 30px;\n    height: 30px;\n    padding: 3px 4px;\n\n}\n.normal {\n    background-color: #43af55;\n}\n.suspended{\n    background-color: #f58e08;\n    padding: 3px 6px;\n}\n.pending{\n    background-color: #ede600e6;\n\n}\n.canceled{\n    background-color: #c73b3b;\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
